// extracted by mini-css-extract-plugin
module.exports =  {"container":"KY0TPVS","country-name":"tlPAMES","countryName":"tlPAMES","score":"lCI7xL0"};